import { apiVersion } from '../utils/spaConstants';

const apiUrl = process.env.apiUrl;
const bookUrl = process.env.bookUrl;
const wwwUrl = process.env.wwwUrl;
const imageUrl = process.env.imageUrl;
const apiHostUrl = process.env.apiHostUrl;
const pclClientCode = process.env.pclClientId;
const NODE_ENV = process.env.NODE_ENV;

export const availableServices = `${apiUrl}/${apiVersion}/services/services-filter`
export const reservedServices = `${apiUrl}/${apiVersion}/bookings/spa-info  `
export const cancelPolarService = `${apiUrl}/${apiVersion}/bookings/{bookingNumber}/spa-cancel `
export const getBenefits = `${apiUrl}/${apiVersion}/spa-benefits`
export const reservationDates = `${apiUrl}/${apiVersion}/services/spa-timeslots`
export const holdReservation = `${apiUrl}/${apiVersion}/services/spa-hold`
export const releaseReservation = `${apiUrl}/${apiVersion}/services/spa-release`
export const getContentFeed = `${apiUrl}/${apiVersion}/spa-details`
export const cancelSteinerReservation = `${apiUrl}/${apiVersion}/services/spa-cancel`
export const polarPayment = `${apiUrl}/${apiVersion}/services/spa-commit`

export const cpNavigationHeaderUrl = `${apiHostUrl}/cpmf/v1.0/booking/cp-menu`;
export const polarItenerariesToken = `${apiHostUrl}/resdb/p1.0/itineraries`;
export const pclClientId = pclClientCode;

export const getProcessUrls = {
        apiUrl: apiUrl, apiHostUrl: apiHostUrl, bookUrl: bookUrl, wwwUrl: wwwUrl, imageUrl: imageUrl, NODE_ENV: NODE_ENV
}

export const paypalUrl = `${apiHostUrl}/crm-wm/p1.0/GenPaypalToken`;
